var React = require('react');

function NavCloseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("path",{"d":"M.6863 21.8995L21.8995.6863 22.96 1.7469 1.747 22.9601z","key":0}),React.createElement("path",{"d":"M1.747 1.0398L22.9602 22.253l-1.0607 1.0607L.6863 2.1005z","key":1})]));
}

NavCloseInline.defaultProps = {"width":"23","height":"24","viewBox":"0 0 23 24"};

module.exports = NavCloseInline;

NavCloseInline.default = NavCloseInline;
